import React from 'react';

import OrganizationMetrics from '../organization/metrics/OrganizationMetrics';
import { history } from '../../state/store';

const OrganizationCard = (props) => {
    const org = props.organization;
    const templateInfo = org && org.template && org.template.templateString;

    if (!org) {
        return (
            <div className="DashboardCard OrganizationCard">
                <i className="fa fa-circle-o-notch m2spin"></i>
                Loading Organization Details...
            </div>
        );
    }

    return (
        <div
            className="DashboardCard OrganizationCard"
            onClick={() => {
                history.push(`/organization/${org.id}`);
            }}>
            <div className="DashboardCard__info">
                <div className="DashboardCard__meta">
                    <div className="DashboardCard__header">
                        <p className="name">{org.name}</p>
                        {templateInfo && (
                            <div className="OrganizationMetrics">
                                <div className="NextCheckinMetrics">
                                    <p className="header templateString">
                                        {templateInfo}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <OrganizationMetrics organization={org} hidePlan={true} />
        </div>
    );
};

export default OrganizationCard;
